import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import {
  ConfigGenericFormDataModel,
  GenerateFormFieldDataModel,
  FilterInputDataPayloadModel,
  GenerateFormFieldModel,
  GenerateFormModel,
  ResponseModelV2,
  RightMenuAction,
  ActionMode,
  DataBroadcastModel,
  DataBroadcast
} from 'src/app/model';
import { DataService } from 'src/app/services';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { GeneralService } from '../../services/general.service';

@Component({
  selector: 'app-right-menu',
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.css'],
  animations: [
    trigger('collapse', [
      state('false', style({
        width: '0px',
      })),
      state('true', style({
        visibility: 'visible'
      })),
      transition('false => true', animate('500ms ease-in')),
      transition('true => false', animate('500ms ease-out'))
    ])
  ]
})
export class RightMenuComponent implements OnInit, OnDestroy {

  @Output() filterAction = new EventEmitter<RightMenuAction>();

  @Input()
  set entityType(value: string) {
    this._entityType = value;
    this._setFilterInputData();
  }

  get entityType() {
    return this._entityType;
  }

  // Flag
  isFilterOpen: boolean = false;
  selectedFilterCount: number = 0;

  // Configuration
  genericFormData: ConfigGenericFormDataModel = {} as ConfigGenericFormDataModel;
  showForm: boolean = false;

  // Setter
  private _entityType: string;

  // Subscription
  private _filterInputDataSubscription: Subscription;
  private _subscription: Subscription;
  
  constructor(
    private _service: ServicecallService,
    private _route: Router,
    private _generalService: GeneralService,
    private _dataSer: DataService
  ) {
    // Broadcast
    this._subscription = this._dataSer.events
    .subscribe({
      next: (broadcast: DataBroadcastModel) => {
        if (broadcast.name === DataBroadcast?.SITE_CHANGED || broadcast.name === DataBroadcast.API_REFRESH) {
          this._setFilterInputData();
        }
      }
    });
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._filterInputDataSubscription?.unsubscribe();
    this._subscription?.unsubscribe();
  }

  /**
   * Determines whether filter icon click on
   */
  onFilterIconClick() {
    this.isFilterOpen = !this.isFilterOpen;
  }

  /**
   * Determines whether form generated on
   * @param event
   */
  onFormGenerated(event: GenerateFormModel) {
    if (event?.actionType === ActionMode?.CANCEL) {
      this.onFilterIconClick();
    } else if (event?.actionType === ActionMode.SUBMIT) {
      const formatedFilterData: GenerateFormFieldDataModel[] = JSON.parse(
        JSON.stringify(event.formValue),
        (key, value) => (value === null || value === '' || value.length == 0) ? undefined : value
      );
      this.filterAction.emit({ filterStatus: this.isFilterOpen, filterData: formatedFilterData });
      this.selectedFilterCount = Object.values(event.formValue)?.filter((filterItem: any) => filterItem != null && filterItem?.length)?.length;
    } else if (event?.actionType === ActionMode.CLEAR) {
      this.selectedFilterCount = Object.values(event.formValue)?.filter((filterItem: any) => filterItem != null && filterItem?.length)?.length;
      this.filterAction.emit({ filterStatus: this.isFilterOpen, filterData: null });
    }
  }

  /**
   * Sets filter input data
   */
  private _setFilterInputData() {
    this.genericFormData = this._service.getConfiguration('genericFormData') ? this._service.getConfiguration('genericFormData') : {} as ConfigGenericFormDataModel;
    this.showForm = this._generalService?.convertObjectToArray(this.genericFormData)?.length ? true : false;
    if (this.showForm) {
      const payloadContent: FilterInputDataPayloadModel = {
        filterInputs: this.genericFormData?.[this.entityType]?.map((item: GenerateFormFieldModel) => item?.path),
        type: this._service.getUrlType(this._route?.url)
      };
      this._filterInputDataSubscription = this._service.filterInputData(payloadContent)
      .subscribe({
        next: (result: ResponseModelV2<GenerateFormFieldDataModel[]>) => {
          if (result?.status && result?.response?.data.length) {
            const filterInputData = result?.response?.data;
            this.genericFormData?.[this.entityType]?.forEach(
              (field: GenerateFormFieldModel) => {
                field.fieldValue = filterInputData?.find((value) => value?.[field?.path])?.[field?.path];
              }
            );
            // Set selected fiter count, if there is any intial value for filter form
            this.selectedFilterCount = this.genericFormData?.[this.entityType]
              ?.filter((formField: GenerateFormFieldModel) => formField?.initialValue)
              ?.length;
          } else {
            this._service.toasterService({ type: 'error', msg: result?.response?.message });
          }
        }
      });
    }
  }

}